export default __webpack_public_path__ + "static/media/036-gps.26496d81.svg";